import React, { useRef, useLayoutEffect } from "react";

const TextInput = ({
  name,
  id = "",
  label,
  ariaLabel = "",
  value,
  handleChange,
  placeholder = "",
  required = false,
  disabled = false,
  errorMessage = {},
  type = "text",
  maxLength,
  cName,
  autoComplete = "off",
  readonly = false,
  handleBlur,
  parentClassName,
  labelClassName,
  onKeyDown,
  inputRef,
  "aria-label": ariaLabelProp,
  "aria-required": ariaRequiredProp,
}) => {
  // const inputRef = useRef(null);
  const caretPosRef = useRef(0);

  // Store caret position before React rerenders
  const handleInputChange = (e) => {
    caretPosRef.current = e.target.selectionStart;
    handleChange(e); // Pass full event to parent
  };

  const isRequired = ariaRequiredProp !== undefined ? ariaRequiredProp : required;
  const ariaLabelText =
    ariaLabelProp ||
    ariaLabel ||
    (typeof label === "string" && label.trim() ? label.trim() : "") ||
    (typeof placeholder === "string" && placeholder.trim() ? placeholder.trim() : "") ||
    (typeof name === "string" && name.trim() ? name.trim() : "") ||
    "Text input";

  return (
    <div className={parentClassName + " mb-3"}>
      {label && (
        <label
          htmlFor={id || name}
          className={`form-label w-100 form-label-custom-visible ${labelClassName}`}
        >
          {label} {isRequired && <span className="text-danger">*</span>}
        </label>
      )}
      <>
        <input
          ref={inputRef}
          type={type}
          className={`fw-normal form-control fs-5 ${cName} ${
            errorMessage[name]?.trim()?.length > 0 ? "input-error" : ""
          }`}
          aria-label={ariaLabelText}
          aria-required={isRequired}
          aria-invalid={Boolean(errorMessage?.[name])}
          aria-describedby={errorMessage?.[name] ? `${id || name}-error` : undefined}
          placeholder={placeholder}
          name={name}
          id={id || name}
          value={value}
          onChange={handleInputChange} // ✅ use custom handler
          onBlur={handleBlur}
          // required={required}
          disabled={disabled}
          maxLength={maxLength}
          autoComplete={autoComplete}
          readOnly={readonly}
          onKeyDown={onKeyDown}
        />
      </>
      {errorMessage &&
        errorMessage[name] &&
        Object?.keys(errorMessage).length > 0 && (
          <div id={`${id || name}-error`} role="alert" className="text-danger fw-700 fs-6">
            {errorMessage && errorMessage[name] && errorMessage[name]}
          </div>
        )}
    </div>
  );
};

export default TextInput;
